<template>
  <div class="display-shown-items-count">
    Показано<b>&nbsp;{{ shownItemsCount }}&nbsp;</b> из <b>&nbsp;{{ totalItemsCount }}&nbsp;</b>
  </div>
</template>

<script>
export default {
  name: "display-shown-items-count",
  props: {
    shownItemsCount: {
      type: Number,
      default: 0,
    },
    totalItemsCount: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style scoped>
.display-shown-items-count {
  font-size: 13px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  position: fixed;
  bottom: 10px;
  right: 50px;
  height: 30px;
  box-shadow: 0px 2px 10px rgba(0, 15, 38, 0.25);
  border-radius: 50px;
  background: #ffffff;
  border: none;
  outline: none;
  z-index: 351;
}
</style>
